/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {Toggle} from './Toggle'
import {Demos} from './Demos'
import {KTSVG} from '../../../helpers'
import RequestUp from '../../../../app/modules/Request'

export function ExploreMain() {
  return (
    <>
      <Toggle />
      {/* begin::Exolore drawer */}
      <div
        id='kt_explore'
        className='bg-body'
        data-kt-drawer='true'
        data-kt-drawer-name='explore'
        data-kt-drawer-activate='true'
        data-kt-drawer-overlay='true'
        data-kt-drawer-width="{default:'350px', 'lg': '475px'}"
        data-kt-drawer-direction='end'
        data-kt-drawer-toggle='#kt_explore_toggle'
        data-kt-drawer-close='#kt_explore_close'
      >
        {/* begin::Card  */}
        <div className='card shadow-none w-100'>
          {/* begin::Header */}
          <div className='m-5 flex justify-between ' id='kt_explore_header'>
            <div className=''>
              <button
                type='button'
                className='btn btn-sm btn-icon explore-btn-dismiss me-n5'
                id='kt_explore_close'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
              </button>
            </div>
            <div>
              <h5 className='card-title fw-bold text-gray-600'>
                پشتیباتی - پاسخ به سوالات | راهنمایی | مشاوره
              </h5>
            </div>

          </div>
          {/* end::Header */}
          {/* begin::Body */}
          <div className='card-body' id='kt_explore_body'>
            {/* begin::Content */}
            <div
              id='kt_explore_scroll'
              className='scroll-y me-n5 pe-5'
              data-kt-scroll='true'
              data-kt-scroll-height='auto'
              data-kt-scroll-wrappers='#kt_explore_body'
              data-kt-scroll-dependencies='#kt_explore_header, #kt_explore_footer'
              data-kt-scroll-offset='5px'
            >
              <div className={'flex justify-center'}>
                <RequestUp />
              </div>
              {/*<div className='mb-7 flex text-right justify-center'>*/}
              {/*  <div className='d-flex  flex-stack'>*/}
              {/*    <h3 className='mb-0'> فرصت های ویژه شما </h3>*/}
              {/*  </div>*/}
              {/*</div>*/}



              {/*<div className='rounded border border-dashed border-gray-300 py-4 px-6 mb-5'>*/}
              {/*  <div className='d-flex flex-stack'>*/}
              {/*    <div className='text-nowrap'>*/}
              {/*      <a*/}
              {/*        className='btn btn-sm btn-success'*/}
              {/*      >*/}
              {/*        خرید*/}
              {/*      </a>*/}
              {/*    </div>*/}
              {/*    <div className='d-flex flex-column'>*/}
              {/*      <div  dir={'rtl'} className='d-flex align-items-center text-right mb-1'>*/}
              {/*        <div className='fs-6 fw-bold text-right text-gray-800 fw-bold mb-0 me-1'>*/}
              {/*          خرید سهام داندانپزشکی*/}
              {/*        </div>*/}
              {/*      </div>*/}
              {/*      <div className='fs-7 text-muted'>     تعداد 100 سهام با تخفیف ویژه برای سهامدران</div>*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*</div>*/}

              {/*<a href={process.env.REACT_APP_PURCHASE_URL} className='btn btn-primary mb-15 w-100'>*/}
              {/*  خرید*/}
              {/*</a>*/}
            </div>
            {/* end::Content */}
          </div>
          {/* end::Body */}
        </div>
        {/* begin::Card */}
      </div>
      {/* end::Exolore drawer */}
    </>
  )
}
